import type { Command } from 'prosemirror-state'

import {
  isInTitlePage,
  setTitlePageVisibility,
} from '#choo-app/lib/editor/plugins/titlePageView'
import { TextSelection } from '#choo-app/lib/editor/selection'

import { getPagination } from './paginationPlugin'

/**
 * Jump to a page in the document, placing the cursor at the end of the first
 * text block on that page
 */
export function jumpToPage(pageIndex: number): Command {
  return (state, dispatch, view) => {
    const page = getPagination(state)?.pages[pageIndex]
    if (!page) return false

    if (dispatch) {
      if (view) view.focus() // safari requires us to focus the editor first

      const tr = state.tr
        .setSelection(TextSelection.nearEndOfBlock(state.doc, page.start))
        .scrollIntoView()
        .setMeta('scroll-target', 'page')

      setTitlePageVisibility(tr, isInTitlePage(tr.selection.from, state))

      dispatch(tr)
    }
    return true
  }
}
